module.exports = {"env":"dev","service":{"baseUrl":"https://apied.gotostage.test.expertcity.com"},"oauth":{"url":"https://authenticationed1.col.test.expertcity.com","client_id":"dbe30d1f-450c-4efa-9f08-e1267f09d205","redirect_url":"http://localhost:3000","enabled":true},"logger":{"source":"wdc-client","source_type":"logging","url":"https://logginged1.col.test.expertcity.com:443"},"identityService":{"baseUrl":"https://iamed1.serversdev.getgo.com"},"broker":{"g2w":{"baseURL":"https://globaled1.g2w.test.expertcity.com"}}}


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/config/devConfig.json
// module id = 736
// module chunks = 0